// extracted by mini-css-extract-plugin
module.exports = {"suggested":"OfferCard_suggested__3TpBa"};